import { CheckCircleFilled } from "@ant-design/icons";
import { Flex, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { CustomButton } from "ui";

interface IProps {
  title?: string;
  successText?: string;
  buttonText?: string;
}

export const ResultModal = observer((props: IProps) => {
  const { title, successText, buttonText } = props;
  const { actionModals } = useStores();

  const closeModal = () => {
    actionModals.closeAll();
  };
  return (
    <Flex vertical align="center" gap="middle">
      <CheckCircleFilled style={{ fontSize: 48, color: "green" }} />
      <Typography.Title level={4}>{title}</Typography.Title>
      <Typography.Text>{successText}</Typography.Text>

      <CustomButton size="middle" htmlType="button" onClick={closeModal}>
        {buttonText ?? "Хорошо"}
      </CustomButton>
    </Flex>
  );
});
